import * as React from 'react';
import Typography from '@mui/material/Typography';
import { useRouter } from 'next/dist/client/router';
import { Form, Modal } from 'react-bootstrap';
import ClassNumber from '../form/ClassNumber';
import ClassNumberAsync from '../form/ClassNumberAsync';
import Button from '@mui/material/Button';
import { v1 } from 'uuid';
import { config } from '_config';
import { useEffect, useState } from 'react';

const cardInfo = {
  id: v1(),
  goods: 'true',
  goodsCategory: null,
  goodsServiceDetail: null,
  clazz: null,
  descriptions: [],
};

export default function TrademarkStep3({
  state,
  validated,
  onHandleCategories,
}) {
  const router = useRouter();
  const isV2 = false; //router.pathname.includes("registration-trademark-2");
  const [showWarningAdd, setShowWarningAdd] = useState(false);
  const [lastWarningCount, setLastWarningCount] = useState(0);

  const handleClose = () => {
    setShowWarningAdd(false);
  };
  const addNewCard = (event) => {
    event.preventDefault();
    if (state.classes.some((item) => item.clazz === null)) {
      //Do nothing
    } else {
      const uniqueClazz = [
        ...new Set(
          state.classes
            .filter((item) => item.clazz !== null)
            .map((item) => item.clazz)
        ),
      ];
      if (uniqueClazz.length >= 5 && uniqueClazz.length > lastWarningCount) {
        setShowWarningAdd(true);
        setLastWarningCount(uniqueClazz.length);
      } else {
        addCard();
      }
    }
  };
  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(price);
  };
  const addCard = () => {
    const clone = JSON.parse(JSON.stringify(cardInfo));
    clone.id = v1(); // Generate a unique ID
    onHandleCategories(state.classes.concat(clone));
    setShowWarningAdd(false); // Close popup if it was open
  };

  const handleChange = (event, id) => {
    onHandleCategories(
      state.classes.map((item) => {
        if (item.id === id) {
          if (event.target.name) {
            return { ...item, goods: event.target.value };
          } else {
            if (event.target.id.includes('goodsCategory')) {
              return {
                ...item,
                goodsCategory: event.target.value,
                clazz: event.target.clazz,
              };
            } else if (event.target.id.includes('descriptions')) {
              item.descriptions[event.target.id.substring(12)] =
                event.target.value;
              return { ...item };
            }
            return { ...item, [event.target.id]: event.target.value };
          }
        } else {
          return item;
        }
      })
    );
  };
  const removeCard = (event, id) => {
    const updatedClasses = state.classes.filter((item) => item.id !== id);
    onHandleCategories(updatedClasses);
    const uniqueClazz = [
      ...new Set(
        updatedClasses
          .filter((item) => item.clazz !== null)
          .map((item) => item.clazz)
      ),
    ];
    if (uniqueClazz.length < lastWarningCount) {
      setLastWarningCount(uniqueClazz.length);
    }
  };
  const isAddDisabled = state.classes.some((item) => item.clazz === null);
  return (
    <div className="question step-3">
      <h2>Choose Your Trademark Class</h2>
      <Form id="TrademarkForm" noValidate validated={validated}>
        <Typography className="regular">
          Start describing the goods and services related to your mark.
          Trademark Genius compares the description you provide and
          automatically provides descriptions from the USPTO ID Manual for your
          consideration.
        </Typography>
        {(state.classes || []).map((item) => (
          <div key={item.id} className="polaroid">
            <div
              style={{
                marginTop: config.skin === 'v2-basic' ? 0 : '20px',
                marginBottom: config.skin === 'v2-basic' ? 0 : '20px',
              }}
              key={item.id}
            >
              <Typography className="primary-label">
                Do you sell, or intend to sell, a goods or service?
              </Typography>
              <Form.Group className="mb-4 ownerTop" controlId={'goods'}>
                <Form.Check
                  inline
                  label="Goods"
                  name={item.id + '_goods'}
                  type="radio"
                  value={'true'}
                  checked={item.goods === 'true'}
                  onChange={() => handleChange(event, item.id)}
                  id={item.id + `goodOrService1`}
                  data-hj-allow
                />

                <Form.Check
                  inline
                  label="Services"
                  type="radio"
                  name={item.id + '_goods'}
                  value={'false'}
                  checked={item.goods === 'false'}
                  onChange={() => handleChange(event, item.id)}
                  id={item.id + `goodOrService2`}
                  data-hj-allow
                />
              </Form.Group>

              {isV2 && (
                <ClassNumber
                  controlId={item.id}
                  goods={item.goods}
                  goodsCategory={item.goodsCategory}
                  onChange={(event) => handleChange(event, item.id)}
                />
              )}

              {!isV2 && (
                <ClassNumberAsync
                  controlId={item.id}
                  classes={state.classes}
                  goods={item.goods}
                  goodsCategory={item.goodsCategory}
                  descriptions={item.descriptions}
                  goodsServiceDetail={item.goodsServiceDetail}
                  validated={validated}
                  onChange={(event) => handleChange(event, item.id)}
                />
              )}

              {state.classes.length > 1 ? (
                <Button
                  className="addOwner"
                  variant="contained"
                  onClick={() => removeCard(event, item.id)}
                >
                  - Remove Class
                </Button>
              ) : (
                ''
              )}
            </div>
          </div>
        ))}
        <Button
          className="addOwner"
          style={{
            marginBottom: '20px',
          }}
          variant="contained"
          onClick={addNewCard}
          disabled={isAddDisabled}
        >
          + Add Class
        </Button>
        {/* Modal for warning */}
        <Modal show={showWarningAdd} onHide={handleClose} centered>
          <Modal.Header closeButton style={{ justifyContent: 'center' }}>
            <Modal.Title style={{ width: '100%', textAlign: 'center' }}>
              Warning
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ justifyContent: 'center' }}>
            <p style={{ textAlign: 'center' }}>
              You have added{' '}
              <strong style={{ fontFamily: 'MontserratBold' }}>
                {
                  [
                    ...new Set(
                      state.classes
                        .filter((item) => item.clazz !== null)
                        .map((item) => item.clazz)
                    ),
                  ].length
                }{' '}
                Trademark Classes
              </strong>{' '}
              so far. Each class has a{' '}
              <strong style={{ fontFamily: 'MontserratBold' }}>
                filing fee of $450
              </strong>
              , bringing your current total in{' '}
              <strong style={{ fontFamily: 'MontserratBold' }}>
                Filing Fees to{' '}
                {formatPrice(
                  [
                    ...new Set(
                      state.classes
                        .filter((item) => item.clazz !== null)
                        .map((item) => item.clazz)
                    ),
                  ].length * 450
                )}
              </strong>
              .
            </p>
            <p style={{ textAlign: 'center' }}>
              Do you wish to continue adding more classes?
            </p>
          </Modal.Body>
          <Modal.Footer style={{ justifyContent: 'center' }}>
            <Button
              className="prev"
              variant="outlined"
              sx={{ mr: 1, mt: 1, mb: 1 }}
              onClick={handleClose}
              style={{
                backgroundColor: '#FFF',
                color: '#03589C',
                fontFamily: 'MontserratBold',
                fontSize: '14px',
                lineHeight: '24px',
                border: '2px solid #ECEDF1',
                textTransform: 'none',
                padding: '14px 45px',
                marginRight: '13px',
              }}
            >
              No
            </Button>
            <Button
              variant="outlined"
              onClick={addCard}
              style={{
                backgroundColor: '#F37217',
                color: '#fff',
                fontFamily: 'MontserratBold',
                fontSize: '14px',
                lineHeight: '24px',
                border: '2px solid #F37217',
                textTransform: 'none',
                padding: '14px 45px',
              }}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
        <br />
        {config.skin !== 'v2-basic' && (
          <small className="text-muted form-text">
            ***Please note, a separate USPTO filing fee of $450 applies per
            class of goods/services.
          </small>
        )}
        {config.skin === 'v2-basic' && (
          <small className="text-muted form-text">
            ** the USPTO requires separate fees for every class of goods/service
            added
          </small>
        )}
      </Form>
    </div>
  );
}
